import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/sns/line.png'
import _imports_1 from '@/assets/img/sns/x.png'
import _imports_2 from '@/assets/img/sns/facebook.png'


const _withScopeId = n => (_pushScopeId("data-v-ec0cfc06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex sns-list mt-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-inner",
  src: _imports_0,
  height: "40",
  width: "40"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-inner",
  src: _imports_1,
  height: "20",
  width: "20"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-inner",
  src: _imports_2,
  height: "24",
  width: "24"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { SnsPlatform } from "@/types/sns/SnsPlatform";


export default /*#__PURE__*/_defineComponent({
  __name: 'SNSLink',
  emits: ["click"],
  setup(__props, { emit: emits }) {



const onClick = (platform: SnsPlatform) => {
  emits("click", platform);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "icon-wrapper line",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick('line')))
    }, _hoisted_3),
    _createTextVNode(),
    _createElementVNode("div", {
      class: "icon-wrapper email",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick('email')))
    }, [
      _createVNode(FeatherIcon, {
        class: "icon-inner",
        icon: "mail",
        size: "24",
        color: "white"
      })
    ]),
    _createTextVNode(),
    _createElementVNode("div", {
      class: "icon-wrapper x",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (onClick('x')))
    }, _hoisted_5),
    _createTextVNode(),
    _createElementVNode("div", {
      class: "icon-wrapper facebook",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (onClick('facebook')))
    }, _hoisted_7)
  ]))
}
}

})